import React, { useCallback, useRef, useState } from 'react'

import { Box } from '@mui/system'
import { Avatar, Button, FormControl, Typography, MenuItem, Divider, Input, IconButton, Modal, Grid } from '@mui/material'
import Select from '@mui/material/Select';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '@mui/icons-material/Close';

import logo from 'assets/images/sectorLogos/logo-horizontal.svg'
import firstPhoto from 'assets/images/courses-page/header-first-photo.png'
import secondPhoto from 'assets/images/courses-page/header-second-photo.png'
import bg from 'assets/images/courses-page/header-illus.svg'

import { FilterIcon, FleshIcon, MenuIcon, PersonIcon, SearchIcon } from 'Sui_Icons'
import { convertToPersianNumber } from 'utils'
import style from './Header.module.scss'
import { Filters } from '../Filters/Filters';
import { Card } from 'components';
import { useEffect } from 'react';
import { SideMenu } from 'components';
import { SuiBox, SuiButton } from 'components'
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";


export const Header = ({check_auth}) => {

    const { user } = useSelector(state => state.auth);
    let headerRef = useRef(null)

    const [filterModalVisiblity, setModalVisiblity] = useState()

    const [offsetFromTop, setOffsetFromTop] = useState(false)

    const handleOffsetStateChange = () => {
        if (window.scrollY > headerRef.current.offsetTop)
            setOffsetFromTop(true)
        else
            setOffsetFromTop(false)
    }
    const callback = useCallback(() => handleOffsetStateChange, [window.scrollY > headerRef.current?.offsetHeight])

    useEffect(() => {
        document.addEventListener('scroll', handleOffsetStateChange)

        return () => {
            document.removeEventListener('scroll', handleOffsetStateChange)
        }
    }, [])


    //Must Be Fetch From Backend

    const numberOfMasters = 60

    const displayInMobile = (normalDisplay) => ({ display: { xs: normalDisplay, lg: 'none' } })
    const displayInDesktop = (normalDisplay) => ({ display: { xs: 'none', lg: normalDisplay } })

    const tempMastersPhotos = [
        "https://avatars.design/wp-content/uploads/2021/02/corporate-avatars-TN-1.jpg",
        "https://www.w3schools.com/w3images/avatar2.png",
        "https://www.w3schools.com/howto/img_avatar.png"]


    const FiltersModal = () => {
        return <>
            <Modal
                open={filterModalVisiblity}
            >
                <>
                    <Grid sx={{ p: 2, background: '#f7f7fdf0' }} container spacing={2}>
                        <Grid item xs={12}>
                            <Card sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography>انتخاب فیلتر</Typography>
                                <IconButton onClick={() => setModalVisiblity(false)}><CloseIcon /></IconButton>
                            </Card>
                        </Grid>

                        <Filters />
                        <Grid item xs={12}>
                            <Button onClick={() => setModalVisiblity(false)} fullWidth variant='contained'><Typography>اعمال</Typography></Button>
                        </Grid>
                    </Grid></>
            </Modal>


        </>
    }

    return (
        <Box sx={{ background: 'white', backgroundImage: { lg: `url(${bg})` }, px: 18, py: { xs: 1, lg: 2 }, maxWidth: { lg: '1920px' }, margin: { lg: ' 0 auto' }, boxSizing: 'border-box' }} ref={headerRef}>
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                position: { xs: 'fixed', lg: 'relative' },
                top: 0, left: 0,
                width: { xs: '100%', lg: 'unset' },
                background: 'white',
                zIndex: 100,
                px: { xs: 2, lg: 0 },
                py: { xs: 0.5, lg: 0 },
                boxSizing: 'border-box',
                transition: 'all ease 0.2s',
                boxShadow: { xs: offsetFromTop ? '0 10px 10px #e2e2e2' : '0 0px 0px #e2e2e2', lg: 'none' }
            }}>
                {/* <IconButton sx={displayInMobile('block')}><MenuIcon /></IconButton> */}
                <Box display={{lg:'none'}}><SideMenu hideLogo/></Box>
                <Box component={Link} to="/" sx={{ maxWidth: { xs: '90px', lg: 'unset' }, mt: 1 }}><img style={{ width: '100%' }} src={logo} /></Box>
                <SuiBox sx={{ display: { xs: 'none', md: 'flex' } }}>
                    <SuiButton component={Link} to="/topcourses" color='action' variant='text' >دوره های آموزشی</SuiButton>
                    <SuiButton component={Link} to="/topquizes" color='action' variant='text' >آزمون ها</SuiButton>
                    <SuiButton component={Link} to="/about_us" color='action' variant='text' >سکتور چیست؟</SuiButton>
                    <SuiButton component={Link} to="/provision" color='action' variant='text'>قوانین و مقررات </SuiButton>
                    <SuiButton component={Link} to="/road_map" color='action' variant='text'>نقشــــــه راه</SuiButton>
                </SuiBox>
                {/* <Button variant='contained' sx={{ ...displayInDesktop('flex') }} color="primary" startIcon={<PersonIcon />}>حساب کاربری</Button> */}

                {user && check_auth ? (       
                            <>                     
                            {user.role === "admin" && (
                                <SuiButton component={Link} to="/admin" variant='contained' color="primary" startIcon={<PersonIcon />}>حساب کاربری</SuiButton>
                            )}
                            {user.role === "teacher" && (
                                <SuiButton component={Link} to="/teacher" variant='contained' color="primary" startIcon={<PersonIcon />}>حساب کاربری</SuiButton>
                            )}
                            {user.role === "creator" && (
                                <SuiButton component={Link} to="/creator" variant='contained' color="primary" startIcon={<PersonIcon />}>حساب کاربری</SuiButton>
                            )}
                            {user.role === "organization" && (
                                 <SuiButton component={Link} to="/organization" variant='contained' color="primary" startIcon={<PersonIcon />}>حساب کاربری</SuiButton>
                            )}
                            {user.role === "sub_organization" && (
                                <SuiButton component={Link} to="/sub_organization" variant='contained' color="primary" startIcon={<PersonIcon />}>حساب کاربری</SuiButton>
                            )}
                            {user.role === "user_organization" && (
                                <SuiButton component={Link} to="/user_organization" variant='contained' color="primary" startIcon={<PersonIcon />}>حساب کاربری</SuiButton>
                            )}
                            {user.role === "user" && (
                                <SuiButton component={Link} to="/user" variant='contained' color="primary" startIcon={<PersonIcon />}>حساب کاربری</SuiButton>
                            )}
                            </>
                            ):(
                                <SuiButton component={Link} to="/user" variant='contained' color="primary" startIcon={<PersonIcon />}>ورود/ثبت نام</SuiButton>
                            )}


                <IconButton sx={displayInMobile('block')} onClick={() => setModalVisiblity(true)}> <FilterIcon /></IconButton>
                <FiltersModal />


            </Box>

            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: { xs: 'center', lg: 'space-between' }, mt: 3, position: 'relative' }}>
                <Box sx={{ ...displayInDesktop('flex'), flexDirection: 'column', positon: 'relative' }}>
                    <img src={firstPhoto} />

                    <Box sx={{ width: '115px', height: '115px', borderRadius: '50%', backgroundColor: 'yellow.main', my: 2 }}>   </Box>
                    <Box sx={{ position: 'absolute', left: '15%', top: '25%', display: { xs: 'none', lg: 'block' } }}>
                        <FleshIcon sx={{ height: '70px', width: '112px' }} />
                    </Box>


                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', mt: { xs: 4, lg: 3 }, textAlign: 'center', justifyContent: 'center', flexBasis: { lg: '60%' } }}>
                    <Box sx={{ my: 1 }}>
                        <Typography fontWeight={'800'} fontSize={{ xs: 20, md: 32 }} display={'inline'} > مسیری آسان برای</Typography>&nbsp;
                        <Typography fontWeight={'800'} color='primary' fontSize={{ xs: 20, md: 32 }} display={'inline'} >یادگیری</Typography>
                        <Typography fontWeight={'800'} fontSize={{ xs: 20, md: 32 }} display={'inline'} >..!</Typography>
                    </Box>
                    <Typography fontSize={{ xs: 13, md: 16 }} color={'grey.600'}>همین الان یادگیری  رو شروع کن ، مسیر موفقیت رو طی کن.</Typography>
                    <Box sx={{ mt: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }} ref={headerRef}>

                        <Typography fontWeight={'800'} fontSize={{ xs: 12, lg: 16 }}>با بیش از {convertToPersianNumber(numberOfMasters)} استاد</Typography>
                        &nbsp;&nbsp;
                        {tempMastersPhotos.map((master, index) => <Avatar sx={{ border: '2px solid white', marginRight: '-25px', zIndex: index + 1, height: 42, width: 42 }} src={master} />)}
                        <Button sx={{ flex: 'none', fontSize: { xs: 15, md: 'none' }, marginRight: '25px', zIndex: tempMastersPhotos.length + 1 }} color='primary' variant='contained' endIcon={<ArrowBackIcon />} >

                            <Typography sx={displayInMobile('block')}>اساتید</Typography>
                            <Typography sx={displayInDesktop('block')}>اساتید سکتور</Typography>
                        </Button>

                    </Box>
                    <Box sx={{ my: { xs: 3, lg: 4 }, display: 'flex', alignItems: 'center', background: 'hsl(207deg 47% 96%)', borderRadius: 1.125, justifyContent: 'flex-start' }}>
                        <FormControl classes={{ root: style.formOutlined }} fullWidth sx={{ border: 'none !important', flexBasis: '50%', ...displayInDesktop('block') }} >
                            {/* <InputLabel id="demo-simple-select-label">دسته بندی&nbsp;</InputLabel> */}
                            <Select
                                labelId="category-select-label"
                                id="category-select"
                                label="Category"
                                sx={{ border: 'none !important' }}
                                defaultValue={' '}
                                variant='outlined'
                            >
                                <MenuItem disabled value={' '}>دسته بندی ها</MenuItem>
                                <MenuItem value={1}>امنیت</MenuItem>
                                <MenuItem value={2}>شبکه</MenuItem>
                                <MenuItem value={3}>حفاظت</MenuItem>
                            </Select>
                        </FormControl>

                        <Divider flexItem sx={{ height: '60px', ...displayInDesktop('block') }} orientation='vertical' />

                        <FormControl sx={{ m: 1 }} fullWidth variant="outlined" >
                            {/* <InputLabel id="demo-simple-select-label">جستجو آموزش&nbsp;</InputLabel> */}
                            <Input
                                disableUnderline
                                placeholder='به دنبال چه آموزشی هستی؟'
                                startAdornment={
                                    <InputAdornment position="start" sx={{ cursor: 'pointer' }}>
                                        <SearchIcon />
                                    </InputAdornment>
                                }
                            />
                        </FormControl>



                    </Box>
                </Box>

                <Box>
                    <Box sx={displayInDesktop('block')}> <img src={secondPhoto} /></Box>
                </Box>
            </Box>

        </Box>
    )
}
